import { useState, } from 'react';


/**
 * Hook to control a modal
 *
 * @param {function} onOpen - callback function called when the modal is opened
 * @param {function} onClose - callback function called when the modal is closed
 */
export default function useModal(onOpen, onClose) {
  const [value, setValue] = useState(false);


  function _onClose(...args) {
    setValue(false);
    if (typeof onClose === 'function') {
      onClose(...args);
    }
  }

  function _onOpen(...args) {
    setValue(true);
    if (typeof onOpen === 'function') {
      onOpen(...args);
    }
  }


  return {
    value,
    onOpen: _onOpen,
    onClose: _onClose,
  };
}
